import type { TCargoTypeOption } from './types';

export const ALL_CARGO_TYPES = 'all';

export const CARGO_TYPE_OPTIONS: { value: TCargoTypeOption; label: string }[] = [
  { value: ALL_CARGO_TYPES, label: 'All' },
  { value: 'FTL', label: 'FTL' },
  { value: 'LTL', label: 'LTL' },
  { value: 'PART_LOAD', label: 'Part load' },
  { value: 'CONTAINER', label: 'Containers' },
];
